import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PROJECT_API } from "./apiRoutes";

// interface UseGetProjectListProps {
//   queryParams?: Omit<UseQueryOptions, "queryKey">;
// }

const getProjectList = async () => {
  return await axiosAuth.get(`${PROJECT_API}`);
};

const useGetProjectList = (
  queryParams?: Omit<UseQueryOptions, "queryKey">
): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["project-list"],
    queryFn: () => getProjectList(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetProjectList;
